import { hiredrateBridgeURL } from "store/hiredrateConst";
import { MAX_RECORDS, MAX_RECORDS_LENGTH } from "store/constant";
import {
  hdFormatDateToDDMMYYYY,
  ttaiAPIFormatDate,
} from "utils/datepicker-util/converters/date";

// hiredrate login URL
export function hiredrateLogInUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/auth/login";
}

// hiredrate logout URL
export function hiredrateLogOutUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/auth/logout";
}

export function jobPositionsGetUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/job_positions";
}

export function jobApplicationsGetUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/applications";
}

export function jobApplicationGetUrlConstruct(fromDate, toDate, keyWord) {
  const baseUrl = hiredrateBridgeURL() + "/v1/applications";
  // Check if both fromDate and toDate are provided
  if (fromDate && toDate && keyWord) {
    // Construct the URL with all three parameters
    return `${baseUrl}?page=1&page_size=20&start_date=${fromDate}&end_date=${toDate}&queryfor_application_name=${keyWord}`;
  } else if (fromDate && toDate && !keyWord) {
    // Construct the URL with only dates
    return `${baseUrl}?page=1&page_size=20&start_date=${fromDate}&end_date=${toDate}`;
  } else if (fromDate) {
    // Construct the URL with only the keyword
    return `${baseUrl}?page=1&page_size=20&application_name_query=${fromDate}`;
  } else {
    // Return the base URL if no appropriate parameter combination is matched
    return baseUrl;
  }
}

export function jobApplicationAllByPageGetUrlConstruct(
  page,
  fromDate,
  toDate,
  query,
) {
  if ((page, fromDate, toDate)) {
    return (
      hiredrateBridgeURL() +
      "/v1/applications?page=" +
      page +
      "&page_size=20&start_date=" +
      fromDate +
      "&end_date=" +
      toDate
    );
  } else if ((page, fromDate, toDate, query)) {
    return (
      hiredrateBridgeURL() +
      "/v1/applications?page=" +
      page +
      "&page_size=20&start_date=" +
      fromDate +
      "&end_date=" +
      toDate +
      "&query_for_application_name=" +
      query
    );
  } else {
    return (
      hiredrateBridgeURL() +
      "/v1/applications?page=" +
      page +
      "&page_size=20&query_for_application_name=" +
      fromDate
    );
  }
}
//http://localhost:8069/v1/job_positions?page=1&page_size=20&start_date=12%2F08%2F2024&end_date=11%2F09%2F2024
export function getJobPositionBasicUrlConstruct(fromDate, toDate) {
  const url =
    hiredrateBridgeURL() +
    `/v1/job_positions?page=1&page_size=20&start_date=${ttaiAPIFormatDate(
      fromDate,
    )}&end_date=${ttaiAPIFormatDate(toDate)}`;
  return url;
}

export function getJobPositionByPageBasicUrlConstruct(page, fromDate, toDate) {
  const url =
    hiredrateBridgeURL() +
    `/v1/job_positions?page=${page}&page_size=20&start_date=${ttaiAPIFormatDate(
      fromDate,
    )}&end_date=${ttaiAPIFormatDate(toDate)}`;
  return url;
}

export function jobApplicationBasicUrlConstruct(fromDate, toDate) {
  const url =
    hiredrateBridgeURL() +
    `/v1/applications?page=1&page_size=20&start_date=${ttaiAPIFormatDate(
      fromDate,
    )}&end_date=${ttaiAPIFormatDate(toDate)}`;
  return url;
}

export function jobApplicationByPageBasicUrlConstruct(page, fromDate, toDate) {
  // const url = `http://localhost:8069/v1/applications?page=1&page_size=20&start_date=${ttaiAPIFormatDate(fromDate)}&end_date=${ttaiAPIFormatDate(toDate)}`
  const url =
    hiredrateBridgeURL() +
    `/v1/applications?page=${page}&page_size=20&start_date=${ttaiAPIFormatDate(
      fromDate,
    )}&end_date=${ttaiAPIFormatDate(toDate)}`;
  return url;
}

// http://localhost:8069/v1/match_analytics?page=1&page_size=9&start_date=21%2F08%2F2024&end_date=20%2F09%2F2024
export function matchAnalysisBasicUrlConstruct(fromDate, toDate) {
  const url =
    hiredrateBridgeURL() +
    `/v1/match_analytics?page=1&page_size=20&start_date=${ttaiAPIFormatDate(
      fromDate,
    )}&end_date=${ttaiAPIFormatDate(toDate)}`;
  return url;
}

export function matchAnalysisByPageBasicUrlConstruct(page, fromDate, toDate) {
  // const url = `http://localhost:8069/v1/applications?page=1&page_size=20&start_date=${ttaiAPIFormatDate(fromDate)}&end_date=${ttaiAPIFormatDate(toDate)}`
  const url =
    hiredrateBridgeURL() +
    `/v1/match_analytics?page=${page}&page_size=20&start_date=${ttaiAPIFormatDate(
      fromDate,
    )}&end_date=${ttaiAPIFormatDate(toDate)}`;
  return url;
}

export function matchAnalysisByJobPosBasicUrlConstruct(
  jobPosId,
  fromDate,
  toDate,
) {
  const url =
    hiredrateBridgeURL() +
    `/v1/match_analytics?page=1&page_size=20&start_date=${ttaiAPIFormatDate(
      fromDate,
    )}&end_date=${ttaiAPIFormatDate(toDate)}&job_position_id=${jobPosId}`;
  return url;
}

export function matchAnalysisByJobPosByPageBasicUrlConstruct(
  page,
  jobPosId,
  fromDate,
  toDate,
) {
  // const url = `http://localhost:8069/v1/applications?page=1&page_size=20&start_date=${ttaiAPIFormatDate(fromDate)}&end_date=${ttaiAPIFormatDate(toDate)}`
  const url =
    hiredrateBridgeURL() +
    `/v1/match_analytics?page=${page}&page_size=20&start_date=${ttaiAPIFormatDate(
      fromDate,
    )}&end_date=${ttaiAPIFormatDate(toDate)}&job_position_id=${jobPosId}`;
  return url;
}

// http://localhost:8069/v1/job_positions/a073db27-936c-401b-a935-ce18e4b6b174/applications?start_date=11%2F08%2F2024&end_date=10%2F09%2F2024
export function getJobApplicationByIdBasicUrlConstruct(
  jobPosId,
  fromDate,
  toDate,
) {
  const url =
    hiredrateBridgeURL() +
    `/v1/job_positions/${jobPosId}/applications?page=1&page_size=20&start_date=${ttaiAPIFormatDate(
      fromDate,
    )}&end_date=${ttaiAPIFormatDate(toDate)}`;
  return url;
}

export function getJobApplicationByIdByPageBasicUrlConstruct(
  jobPosId,
  page,
  fromDate,
  toDate,
) {
  // const url = `http://localhost:8069/v1/applications?page=1&page_size=20&start_date=${ttaiAPIFormatDate(fromDate)}&end_date=${ttaiAPIFormatDate(toDate)}`
  const url =
    hiredrateBridgeURL() +
    `/v1/job_positions/${jobPosId}/applications?page=${page}&page_size=20&start_date=${ttaiAPIFormatDate(
      fromDate,
    )}&end_date=${ttaiAPIFormatDate(toDate)}`;
  return url;
}
export function jobAppliCationFIltersByPageUrlConstruct(
  page,
  filterValues,
  keyword,
) {
  const params = new URLSearchParams();
  if(!filterValues.disabledDate){
  if (filterValues.start_date) {
    const formattedStartDate = hdFormatDateToDDMMYYYY(
      new Date(filterValues.start_date),
    );
    params.append("start_date", formattedStartDate);
  }

  if (filterValues.end_date) { 
    const formattedEndDate = hdFormatDateToDDMMYYYY(
      new Date(filterValues.end_date),
    );
    params.append("end_date", formattedEndDate);
  }
  }

  if (filterValues.min_salary) {
    params.append("min_salary", filterValues.min_salary);
  }

  if (filterValues.jobApplicationName) {
    params.append("application_name_query", filterValues.jobApplicationName);
  }

  if (keyword) {
    params.append("application_name_query", keyword);
  }

  if (filterValues.max_salary) {
    params.append("max_salary", filterValues.max_salary);
  }

  if (filterValues.min_experience && filterValues.min_experience !==  "") {
    params.append("min_experience", filterValues.min_experience);
  }

  if (filterValues.max_experience && filterValues.max_experience !==  "") {
    params.append("max_experience", filterValues.max_experience);
  }

  if (filterValues.job_position_ids) {
    params.append("job_position_ids", filterValues.job_position_ids);
  }

  if (filterValues.stage_ids) {
    params.append("stage_ids", filterValues.stage_ids);
  }

  if (filterValues.analytic_status) {
    params.append("analytic_status", filterValues.analytic_status);
  }

  if (filterValues.order_by) {
    params.append("order_by", filterValues.order_by);
  }

  const url =
    hiredrateBridgeURL() +
    `/v1/applications?page=${page}&page_size=20&${params.toString()}`;
  return url;
}

export function jobAppliCationByJobPosFIltersByPageUrlConstruct(
  page,
  filterValues,
  keyword,
  jobPositionId,
) {
  const params = new URLSearchParams();
  if (filterValues.start_date) {
    const formattedStartDate = hdFormatDateToDDMMYYYY(
      new Date(filterValues.start_date),
    );
    params.append("start_date", filterValues.start_date);
  }

  if (filterValues.end_date) {
    const formattedEndDate = hdFormatDateToDDMMYYYY(
      new Date(filterValues.end_date),
    );
    params.append("end_date", filterValues.end_date);
  }

  if (filterValues.min_salary) {
    params.append("min_salary", filterValues.min_salary);
  }

  if (keyword) {
    params.append("application_name_query", keyword);
  }

  if (filterValues.max_salary) {
    params.append("max_salary", filterValues.max_salary);
  }

  if (filterValues.min_experience !== undefined) {
    params.append("min_experience", filterValues.min_experience);
  }

  if (filterValues.max_experience !== undefined) {
    params.append("max_experience", filterValues.max_experience);
  }

  // if (filterValues.job_position_ids) {
  //   params.append("job_position_ids", filterValues.job_position_ids);
  // }

  if (filterValues.stage_ids) {
    params.append("stage_ids", filterValues.stage_ids);
  }

  if (filterValues.analytic_status) {
    params.append("analytic_status", filterValues.analytic_status);
  }

  if (filterValues.order_by) {
    params.append("order_by", filterValues.order_by);
  }

  const url =
    hiredrateBridgeURL() +
    `/v1/applications?page=${page}&page_size=20&job_position_ids=${jobPositionId}&${params.toString()}`;
  return url;
}

export function matchAnalysisFIltersByPageUrlConstruct(
  page,
  filterValues,
  keyword,
) {
  const params = new URLSearchParams();
  if(!filterValues.disabledDate){
if (filterValues.start_date) {
    const formattedStartDate = hdFormatDateToDDMMYYYY(
      new Date(filterValues.start_date),
    );
    params.append("start_date", formattedStartDate);
  }
  if (filterValues.end_date) {
    const formattedEndDate = hdFormatDateToDDMMYYYY(
      new Date(filterValues.end_date),
    );
    params.append("end_date", formattedEndDate);
  }
  }
  

  if (keyword) {
    params.append("match_analysis_name", keyword);
  }

  

  if (filterValues.job_position_id) {
    params.append("job_position_id", filterValues.job_position_id);
  }

  if (filterValues.application_id) {
    params.append("application_id", filterValues.application_id);
  }

  if (filterValues.state) {
    params.append("state", filterValues.state);
  }

  if (filterValues.applicant_name) {
    params.append("applicant_name", filterValues.applicant_name);
  }

  if (filterValues.matchAnalysisName) {
    params.append("match_analysis_name", filterValues.matchAnalysisName);
  }

  const url =
    hiredrateBridgeURL() +
    `/v1/match_analytics?page=${page}&page_size=20&${params.toString()}`;
  return url;
}

export function getJobPositionFIltersByPageUrlConstruct(
  page,
  filterValues,
) {
  const params = new URLSearchParams();
  if (!filterValues.disabledDate) {

  if (filterValues.start_date) {
    const formattedStartDate = hdFormatDateToDDMMYYYY(
      new Date(filterValues.start_date),
    );
    params.append("start_date", formattedStartDate);
  }

  if (filterValues.end_date) { 
    const formattedEndDate = hdFormatDateToDDMMYYYY(
      new Date(filterValues.end_date),
    );
    params.append("end_date", formattedEndDate);
  }
}

  

  if (filterValues.order_by) {
    params.append("order_by", filterValues.order_by);
  }

  if (filterValues.application_id) {
    params.append("application_id", filterValues.application_id);
  }

  if (filterValues.location) {
    params.append("location", filterValues.location);
  }

  if (filterValues.query) {
    params.append("query", filterValues.query);
  }

  if (filterValues.state) {
    params.append("state", filterValues.state);
    // filterValues.state = status;
  }

  if (filterValues.offer) {
    params.append("offers", filterValues.offer);
    // filterValues.offers = offer;
  }

  const url =
    hiredrateBridgeURL() +
    `/v1/job_positions?page=${page}&page_size=20&${params.toString()}`;
  return url;
}

export function jobPositionByPageGetUrlConstruct(fromDate, toDate, page) {
  if ((fromDate, toDate, page)) {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions?start_date=" +
      fromDate +
      "&end_date=" +
      toDate +
      "&page=" +
      page +
      "&page_size=20"
    );
  } else {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions?query=" +
      fromDate +
      "&page=" +
      toDate +
      "&page_size=20"
    );
  }
}

// http://localhost:8069/v1/job_positions?query=e&page=2&page_size=20
export function jobPositionQueryByPageGetUrlConstruct(query, page = 1) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions?query=" +
    query +
    "&page=" +
    page +
    "&page_size=" +
    MAX_RECORDS
  );
}

// job position fetch
export function jobPositionsListingUrlConstruct(fromDate, toDate, keyWord) {
  const baseUrl = hiredrateBridgeURL() + "/v1/job_positions";

  // Check if both fromDate and toDate are provided
  if (fromDate && toDate && keyWord) {
    // Construct the URL with all three parameters
    return `${baseUrl}?query=${keyWord}&start_date=${fromDate}&end_date=${toDate}`;
  } else if (fromDate && toDate && !keyWord) {
    // Construct the URL with only dates
    return `${baseUrl}?start_date=${fromDate}&end_date=${toDate}`;
  } else if (fromDate) {
    // Construct the URL with only the keyword
    return `${baseUrl}?query=${fromDate}&page=1&page_size=20`;
  } else {
    // Return the base URL if no appropriate parameter combination is matched
    return baseUrl;
  }
}
// http://localhost:8069/v1/job_positions?page=1&page_size=200
export function allJobPositionListing() {
  return hiredrateBridgeURL() + "/v1/job_positions?no_limit=true";
}
// job position detail fetch by jobpositionid
//// http://localhost:8069/v1/job_positions/jhbjb/job_position

export function jobPositionDetailsUrlConstruct(jobPosId) {
  return hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId;
}
export function DeleteJobPositionsUrlConstruct(jobPosId) {
  return hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId;
}

// fetch jP skill details

export function jobPositionSkillDetailsUrlConstruct(jobPosId) {
  return hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId + "/skills";
}

// post call job Position

export function PostjobPositionsUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/job_positions";
}

export function getApplicantsbyjobPosIdGetUrlConstruct(
  jobPosId,
  fromDate,
  toDate,
  keyWord,
) {
  const baseUrl =
    hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId + "/applications";
  // Check if both fromDate and toDate are provided
  if (fromDate && toDate && keyWord) {
    // Construct the URL with all three parameters
    return `${baseUrl}?start_date=${fromDate}&end_date=${toDate}&query_for_application_name=${keyWord}`;
  } else if (fromDate && toDate && !keyWord) {
    // Construct the URL with only dates
    return `${baseUrl}?start_date=${fromDate}&end_date=${toDate}`;
  } else if (fromDate) {
    // Construct the URL with only the keyword
    return `${baseUrl}?query_for_application_name=${fromDate}`;
  } else {
    // Return the base URL if no appropriate parameter combination is matched
    return baseUrl;
  }
}

export function jobApplicationByPageGetUrlConstruct(
  jobPosId,
  page,
  fromDate,
  toDate,
  query,
) {
  if ((jobPosId, page, fromDate, toDate)) {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/applications?page=" +
      page +
      "&page_size=20&start_date=" +
      fromDate +
      "&end_date=" +
      toDate
    );
  } else if ((jobPosId, page, fromDate, toDate, query)) {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/applications?page=" +
      page +
      "&page_size=20&start_date=" +
      fromDate +
      "&end_date=" +
      toDate +
      "&query_for_application_name=" +
      query
    );
  } else {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/applications?page=" +
      page +
      "&page_size=20&query_for_application_name=" +
      fromDate
    );
  }
}

// update jobPosition by id

export function updateJobPositionsUrlConstruct(jobPosId) {
  return hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId;
}

export function updateJobPositionsParseUrlConstruct(jobPosId) {
  return (
    hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId + "/update_parse"
  );
}
export function updateJobPositionsDescriptionUrlConstruct(jobPosId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/job_position_details"
  );
}

export function updateJobPositionsExperienceUrlConstruct(jobPosId) {
  return hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId + "/experience";
}

export function updateJobPositionsQualificationUrlConstruct(jobPosId) {
  return (
    hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId + "/qualifications"
  );
}

export function updateJobPositionsCertificationUrlConstruct(jobPosId) {
  return (
    hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId + "/certifications"
  );
}

// fetch applicant by job position and applicantID

export function jobApplicantByIdGetUrlConstruct(jobPosId, applicantId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicantId
  );
}
export function deleteApplicationsUrlConstruct(jobPosId) {
  return (
    hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId + "/applications"
  );
}

export function deleteMultiApplicationsUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/applications";
}

// fetch applicant by applicant Id

export function applicantDetailsGetUrlConstruct(applicantId) {
  return hiredrateBridgeURL() + "/v1/applications/" + applicantId;
}

export function getDashboardJobPositionGetUrlConstruct(fromDate, toDate) {
  return (
    hiredrateBridgeURL() +
    "/v1/dashboard/job_positions?from_date=" +
    fromDate +
    "&to_date=" +
    toDate
  );
}

export function getDashboardMatchAnalyticsGetUrlConstruct(fromDate, toDate) {
  return (
    hiredrateBridgeURL() +
    "/v1/dashboard/match_analytics?from_date=" +
    fromDate +
    "&to_date=" +
    toDate
  );
}

// http://localhost:8069/v1/dashboard
export function getDashboardGetUrlConstruct(fromDate, toDate) {
  return (
    hiredrateBridgeURL() +
    "/v1/dashboard?from_date=" +
    fromDate +
    "&to_date=" +
    toDate
  );
}

export function getDashboardRecentApplicationGetUrlConstruct(fromDate, toDate) {
  return (
    hiredrateBridgeURL() +
    "/v1/dashboard/applications?from_date=" +
    fromDate +
    "&to_date=" +
    toDate
  );
}

// get all match analytics
export function matchAnalysisConstruct() {
  return hiredrateBridgeURL() + "/v1/match_analytics";
}

export function matchAnalysisConstructByPage(page) {
  return (
    hiredrateBridgeURL() + "/v1/match_analytics?page=" + page + "&page_size=20"
  );
}

//fetch All match Analysis Listing

export function getAllMatchAnalysis(page, pageSize, fromDate, toDate) {
  if ((page, pageSize, fromDate, toDate)) {
    return (
      hiredrateBridgeURL() +
      "/v1/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize +
      "&start_date=" +
      fromDate +
      "&end_date=" +
      toDate
    );
  } else if ((page, pageSize, fromDate)) {
    return (
      hiredrateBridgeURL() +
      "/v1/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize +
      "&start_date=" +
      fromDate
    );
  } else if ((page, pageSize)) {
    return (
      hiredrateBridgeURL() +
      "/v1/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize
    );
  } else {
    return hiredrateBridgeURL() + "/v1/match_analytics";
  }
}

export function getAllMatchAnalysisByPage(page, pageSize, fromDate, toDate) {
  if ((page, pageSize, fromDate, toDate)) {
    return (
      hiredrateBridgeURL() +
      "/v1/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize +
      "&start_date=" +
      fromDate +
      "&end_date=" +
      toDate
    );
  } else if ((page, pageSize, fromDate)) {
    return (
      hiredrateBridgeURL() +
      "/v1/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize +
      "&start_date=" +
      fromDate
    );
  } else if ((page, pageSize)) {
    return (
      hiredrateBridgeURL() +
      "/v1/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize
    );
  } else {
    return hiredrateBridgeURL() + "/v1/match_analytics";
  }
}

// fetch match analysis listing based on job position
export function matchAnalysisListingByJPId(
  jobPosId,
  page,
  pageSize,
  fromDate,
  toDate,
) {
  if ((jobPosId, page, pageSize, fromDate, toDate)) {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize +
      "&start_date=" +
      fromDate +
      "&end_date=" +
      toDate
    );
  } else if ((jobPosId, page, pageSize, fromDate)) {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize +
      "&start_date=" +
      fromDate
    );
  } else if ((jobPosId, page, pageSize)) {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize
    );
  } else {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/match_analytics"
    );
  }
}

// fetch match analysis listing based on job position and page number
export function matchAnalysisListingByPage(
  jobPosId,
  page,
  pageSize,
  fromDate,
  toDate,
) {
  if ((jobPosId, page, pageSize, fromDate, toDate)) {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize +
      "&start_date=" +
      fromDate +
      "&end_date=" +
      toDate
    );
  } else if ((jobPosId, page, pageSize, fromDate)) {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize +
      "&start_date=" +
      fromDate
    );
  } else if ((jobPosId, page, pageSize)) {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/match_analytics?page=" +
      page +
      "&page_size=" +
      pageSize
    );
  } else {
    return (
      hiredrateBridgeURL() +
      "/v1/job_positions/" +
      jobPosId +
      "/match_analytics"
    );
  }
}

// fetch match analysis listing based on job position
export function matchAnalyticsDetails(jobPosId, matchAnalyticId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/match_analytics/" +
    matchAnalyticId +
    "?skills=matched"
  );
}

// fetch all skills
// export function getAllSkillsUrlConstruct() {
//   return hiredrateBridgeURL() + "/v1/skills";
// }
export function getAllSkillsUrlConstruct(companyId = null) {
  const baseUrl = hiredrateBridgeURL() + "/v1/skills2";
  if (companyId) {
    return `${baseUrl}?company_id=${companyId}`;
  }
  return baseUrl;
}
export function postAllSkillsUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/skills";
}

// fetch all skills
export function getAllTagsUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/tags";
}

export function deleteSkillUrlConstruct(jobPosId, applicantId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicantId +
    "/skills"
  );
}

export function deleteCertifiacteUrlConstruct(jobPosId, applicantId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicantId +
    "/certifications"
  );
}

export function deleteEducationUrlConstruct(jobPosId, applicantId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicantId +
    "/educational_details"
  );
}

export function deleteEmploymentUrlConstruct(jobPosId, applicantId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicantId +
    "/employment_details"
  );
}

// fetch all certifications
export function getAllCertificationsUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/certifications";
}

// post all certifications
export function postAllCertificationsUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/certifications";
}

// fetch all qualification

export function getAllQualificationUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/qualifications";
}

export function degreesUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/degrees";
}

// fetch/post qualification major

export function getQualificationMajorUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/major_qualifications";
}

export function getQualificationMajorsUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/qualification_majors";
}
export function getQualificationTypesUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/qualification_types";
}
export function getQualificationLevelsUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/qualification_levels";
}

// create applicant for job position

export function postApplicantForJPUrlConstruct(jobPosID) {
  return (
    hiredrateBridgeURL() + "/v1/job_positions/" + jobPosID + "/applications"
  );
}
export function postpositionDocumentForJPUrlConstruct(jobPosID) {
  return hiredrateBridgeURL() + "/v1/job_positions/" + jobPosID + "/documents";
}
export function postApplicantDocumentForJPUrlConstruct(applicantId) {
  return hiredrateBridgeURL() + "/v1/applicant/" + applicantId + "/documents";
}

//Compare Applicants data fetch by jobposid and matchanalytic id
export function getCompareApplicantUrlConstruct(
  jobPosID,
  matchId,
  applicant1,
  applicant2,
) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosID +
    "/match_analytics/" +
    matchId +
    "/comparision?applicants=" +
    applicant1 +
    "%2C" +
    applicant2
  );
}

//get applicants based on jp id
export function getApplicantsMAUrlConstruct(jobPosID) {
  return (
    hiredrateBridgeURL() + "/v1/job_position/" + jobPosID + "/applications"
  );
}

export function getDraftMAListingUrlConstruct(jobPosID, maId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosID +
    "/id/" +
    maId +
    "/match_analytic"
  );
}

export function updateDraftMAListingUrlConstruct(jobPosID, maId) {
  return hiredrateBridgeURL() + "/v1/job_positions/" + jobPosID + "/id/" + maId;
}

export function runDraftMatchAnalysisUrlConstruct(jobPosID, maId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosID +
    "/id/" +
    maId +
    "/run"
  );
}
// http://localhost:8069/v1/job_positions/e6be6ff3-52a8-495b-b599-8cbff660c736/id/577/run

// http://localhost:8069/v1/job_positions/e6be6ff3-52a8-495b-b599-8cbff660c736/id/577

// http://localhost:8069/v1/job_positions/e6be6ff3-52a8-495b-b599-8cbff660c736/id/577/match_analytic

export function postApplicantsMAUrlConstruct(jobPosID) {
  return (
    hiredrateBridgeURL() + "/v1/job_positions/" + jobPosID + "/match_analytics"
  );
}

// http://localhost:8069/v1/job_positions/e6be6ff3-52a8-495b-b599-8cbff660c736/match_analytics

//User Profile API
export function getUserUrlConstruct(id) {
  // http://192.168.1.132:8069/v1/auth/profile/user/2
  return hiredrateBridgeURL() + "/v1/auth/profile/user/" + id;
}

//Partner Profile API
export function getPartnerUrlConstruct(id) {
  return hiredrateBridgeURL() + "/v1/auth/profile/partner/" + id;
}

export function getSubscriptionUrlConstruct(id) {
  return hiredrateBridgeURL() + "/v1/auth/profile/cmp/" + id;
}

export function updateCompanyUrlConstruct(id) {
  return hiredrateBridgeURL() + "/v1/auth/cmp/" + id + "/profile";
}

// update user details
export function updateUserDetailUrlConstruct(userId) {
  return hiredrateBridgeURL() + "/v1/auth/profile/users/" + userId;
}

//Role API Construct
export function getUserRoleUrlConstruct(id) {
  return hiredrateBridgeURL() + "/v1/users";
}

//Role API Construct
export function getCompanyUsersConstruct(id) {
  return hiredrateBridgeURL() + "/v1/company/" + id + "/users";
}

//Set User Password
export function setUserPasswordURLConstruct(uid) {
  return hiredrateBridgeURL() + "/v1/auth/users/" + uid + "/set-password";
}

//Set User Password
export function setNewUserPasswordURLConstruct(uid) {
  return hiredrateBridgeURL() + "/v1/auth/users/" + uid + "/set-new-password";
}

export function getAllUserRoleUrlConstruct(id) {
  return hiredrateBridgeURL() + "/v1/auth/user/role/" + id;
}

export function PostUserUrlConstruct(id) {
  return hiredrateBridgeURL() + "/v1/roles/user/create_user/" + id;
}

export function getJobPositionDocUrlConstruct(jobPosID) {
  return hiredrateBridgeURL() + "/v1/job_positions/" + jobPosID + "/documents/";
}
export function getJobApplicationDocUrlConstruct(jobPosID, applicantId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosID +
    "/applications/" +
    applicantId +
    "/documents"
  );
}

export function deleteMatchAnalysisUrlConstruct(jpid, maid) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jpid +
    "/match_analytics/" +
    maid
  );
}

// http://localhost:8069/v1/job_positions/3baa617c-7924-4c49-bab7-9851ef94b62e/match_analytics/draft/51

export function deleteMatchAnalysisDraftUrlConstruct(jpid, did) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jpid +
    "/match_analytics/draft/" +
    did
  );
}

// update applicant stage
// http://localhost:8069/v1/job_positions/3614f0a4-fb76-4877-83c5-14abffed1485/applications/a27d6c23-3a07-42b8-a6a8-4ba35bc791c4/stages

export function applicationsStageUpdateUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/applications/stages";
}

// fetch skill rank
//http://localhost:8069/v1/job_positions/3614f0a4-fb76-4877-83c5-14abffed1485/match_analytics/bce39e8b-17ab-4fae-9054-4560f0fbc8b0/data/skills
export function getSkillRanksForMatchAnalysis(jobPosId, matchAnalyticId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/match_analytics/" +
    matchAnalyticId +
    "/data/skills"
  );
}

export function getApplicationStageDetails(jobPosId, applicationId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicationId +
    "/trackings?description=Stage"
  );
}

export function getPricingUrlConstruct(id) {
  return hiredrateBridgeURL() + "/v1/pricing/" + id;
}

export function createSubscriptionURL() {
  return hiredrateBridgeURL() + "/v1/signup";
}

export function checkUserURL(email) {
  return hiredrateBridgeURL() + "/v1/auth/check_user/" + email;
}

export function checkCompanyNameURL(company) {
  return hiredrateBridgeURL() + "/v1/auth/check_company/" + company;
}

export function checkCompanyEmailURL(company) {
  return hiredrateBridgeURL() + "/v1/auth/check_email/" + company;
}

export function initiateCheckoutURL() {
  return hiredrateBridgeURL() + "/v1/initiate-subscription-checkout";
}

export function createTrialAccountURL() {
  return hiredrateBridgeURL() + "/v1/create-trial-account";
}

export function checkSubscriptionStatusURL(customerId) {
  return hiredrateBridgeURL() + "/v1/check-subscription-status?customer_id=" + customerId;
}


export function createAccountURL() {
  return hiredrateBridgeURL() + "/v1/internal-signup";
}

export function confirmSubscriptionURL() {
  return hiredrateBridgeURL() + "/v1/confirm-subscription";
}




export function getApplicationLogNotes(jobPosId, applicationId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicationId +
    "/trackings?description=log_message"
  );
}

export function getApplicationLogUpdates(jobPosId, applicationId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicationId +
    "/trackings"
  );
}

export function fetchMALogNotesResp(jobPosId, matchAnalysisId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/match_analytics/" +
    matchAnalysisId +
    "/log_notes"
  );
}

export function postApplicationLogNoteURL(jobPosId, applicationId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicationId +
    "/log_notes"
  );
}

export function postMALogNoteURL(jobPosId, matchAnalysisId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/match_analytics/" +
    matchAnalysisId +
    "/log_notes"
  );
}

export function getMessagesForUser(userId, page, type) {
  return (
    hiredrateBridgeURL() +
    "/v1/mail_messages?user_id=" +
    userId +
    "&received=true&page=" +
    page +
    "&page_size=10"
  );
}

export function getUnreadMessageCount(userId) {
  return (
    hiredrateBridgeURL() + "/v1/mailmessages/unread-count?user_id=" + userId
  );
}

export function getReceivedTaggedForUser(userId, page) {
  return (
    hiredrateBridgeURL() +
    "/v1/mailmessages?user_id=" +
    userId +
    "&direction=received&page=" +
    page +
    "&page_size=20"
  );
}

export function readMessageUrl(userId, page) {
  return hiredrateBridgeURL() + "/v1/mailmessages/mark-read";
}

export function getSentTaggedForUser(userId, page) {
  return (
    hiredrateBridgeURL() +
    "/v1/mailmessages?user_id=" +
    userId +
    "&direction=sent&page=" +
    page +
    "&page_size=20"
  );
}

export function getSentMessagesForUser(userId, page, type) {
  return (
    hiredrateBridgeURL() +
    "/v1/mail_messages?user_id=" +
    userId +
    "&received=false&page=" +
    page +
    "&page_size=10"
  );
}

export function viewApplicationLogAttachmentURL(
  jobPosId,
  applicationId,
  logId,
  attachmentId,
) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicationId +
    "/log_notes/" +
    logId +
    "/attachments/" +
    attachmentId
  );
}

export function viewMALogAttachmentURL(jobPosId, mAId, logId, attachmentId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/match_analytics/" +
    mAId +
    "/log_notes/" +
    logId +
    "/attachments/" +
    attachmentId
  );
}

export function getJPFileURL(jobPosId, docId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/documents/" +
    docId
  );
}

export function getApplicationFileURL(jobPosId, applicationId, docId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicationId +
    "/documents/" +
    docId
  );
}

export function maAttachmentDeleteURL(jobPosId, mAId, docId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/match_analytics/" +
    mAId +
    "/documents/" +
    docId
  );
}

export function applicationMatrixURL(jobPosId, applicationId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosId +
    "/applications/" +
    applicationId +
    "/application_metrics"
  );
}

export function getAllCompanyUsersUrlConstruct(id) {
  return hiredrateBridgeURL() + "/v1/users?current_user=false";
}

export function updateJobPositionsRcrtrUrlConstruct(jobPosId, userId) {
  return (
    hiredrateBridgeURL() + "/v1/job_positions/" + jobPosId + "/users/" + userId
  );
}

// Send Password Email
export function senEmailForPasswordUrlConstruct(userId) {
  return (
    hiredrateBridgeURL() +
    "/v1/auth/send-email/" +
    userId +
    "/set-new-user-password"
  );
}

export function getMADraftListingUrlConstruct(jobPositionId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPositionId +
    "/match_analytics?page=1&page_size=20&state=draft"
  );
}

export function updateDraftMAapplicantListingUrlConstruct(jobPosID, maId) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPosID +
    "/id/" +
    maId +
    "/draft"
  );
}

export function getAllcurrencyListUrlConstruct(jobPosId) {
  return hiredrateBridgeURL() + "/v1/currencies";
}

export function getAllCurrenciesListUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/allcurrencies?active=false";
}

export function updateCurrencyUrlConstruct(currencyId) {
  return hiredrateBridgeURL() + "/v1/currencies/" + currencyId;
}

export function getAllApplicationsMeasuresListUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/applications11/measures";
}

export function getApplicationMetricsThresholdURLConstruct(companyId) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/application_threshold/?company=" +
    companyId
  );
}

export function getJOBApplicationMetricsThresholdURLConstruct(companyId) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/job_position_application_threshold/?company=" +
    companyId
  );
}

export function putApplicationMetricsThresholdURLConstruct(companyId) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/application_metrics_threshold/?company=" +
    companyId
  );
}

export function unlinkJobApplicationMetricsThresholdURLConstruct(
  companyId,
  jobId,
) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/unlink_job_metrics/?company=" +
    companyId +
    "&job=" +
    jobId
  );
}

export function unlinkApplicationMetricsThresholdURLConstruct(
  companyId,
  level,
) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/unlink_metrics/?company=" +
    companyId +
    "&sel_type=" +
    level
  );
}
export function getAllStagesUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/stages";
}

export function createStageUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/stage";
}

export function updateStageUrlConstruct(stageId) {
  return hiredrateBridgeURL() + "/v1/stages/" + stageId;
}

export function deleteStageUrlConstruct(stageId) {
  return hiredrateBridgeURL() + "/v1/stages/" + stageId;
}

export function getJobAMTUrlConstruct(companyID, jobID) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/job_application_threshold/?company=" +
    companyID +
    "&job_id=" +
    jobID +
    "&level=job"
  );
}

export function putJobAMTUrlConstruct(companyID, jobID) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/job_spec_application_metrics_threshold/?company=" +
    companyID +
    "&job=" +
    jobID
  );
}

export function putAMTEnableUrlConstruct(companyID, level) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/enable_metrics/?company=" +
    companyID +
    "&sel_type=" +
    level
  );
}

export function putDefaultAMTEnableUrlConstruct(companyID, level) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/enable_default_metrics/?company=" +
    companyID +
    "&sel_type=" +
    level
  );
}

export function putJobAMTEnableUrlConstruct(companyID, level, jobId) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/enable_default_metrics/?company=" +
    companyID +
    "&sel_type=" +
    level +
    "&job_id=" +
    jobId
  );
}

export function getApplicationMeasuresBasedonDateRange(
  selectedFromDate,
  selectedToDate,
) {
  return (
    hiredrateBridgeURL() +
    "/v1/applications11/measures?page=1&page_size=20&start_date=" +
    selectedFromDate +
    "&end_date=" +
    selectedToDate
  );
}

export function getApplicationMeasuresBasedonDateRangeByJobPos(
  selectedFromDate,
  selectedToDate,
  jobPosId,
) {
  return (
    hiredrateBridgeURL() +
    "/v1/applications11/measures?page=1&page_size=20&start_date=" +
    selectedFromDate +
    "&end_date=" +
    selectedToDate +
    "&job_position_id=" +
    jobPosId
  );
}

export function getDocLimitURL(company_id, doc_type) {
  return (
    hiredrateBridgeURL() +
    "/v1/auth/cmp/limit/" +
    company_id +
    "?doc_type=" +
    doc_type
  );
}

export function stopTouringURL(company_id) {
  return hiredrateBridgeURL() + "/v1/auth/stop_tour/" + company_id;
}

export function getAllJobApplicationsNoLimit() {
  return (
    hiredrateBridgeURL() + "/v1/applications?page=1&page_size=200&no_limit=true"
  );
}

export function getChartsExpansionData(company_id) {
  return (
    hiredrateBridgeURL() +
    "/v1/hiredrate/settings/charts_expanded?company_id=" +
    company_id
  );
}

export function createPortalSessionURL() {
  return hiredrateBridgeURL() + "/v1/api/get_checkout_url/";
}
export function createCheckoutPortalSessionURL() {
  return hiredrateBridgeURL() + "/v1/api/generate_checkout_existing_url/";
}

export function detailNotesURL(
  jobPositionId,
  applicationId,
  detailType,
  detailId,
) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPositionId +
    "/applications/" +
    applicationId +
    "/mail_message_details?detail_type=" +
    detailType +
    "&detail_id=" +
    detailId
  );
}

export function detailNotesWithNoRefIDURL(
  jobPositionId,
  applicationId,
  detailType,
) {
  return (
    hiredrateBridgeURL() +
    "/v1/job_positions/" +
    jobPositionId +
    "/applications/" +
    applicationId +
    "/mail_message_details?detail_type=" +
    detailType
  );
}

// Tour API URL Constructors
export function createTourUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/tour";
}

export function updateTourUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/tour";
}

export function getTourStatusUrlConstruct(userId) {
  return hiredrateBridgeURL() + "/v1/tour_status/" + userId;
}

export function skillComparisonURLConstruct(jobPositionId) {
  return (
    hiredrateBridgeURL() +
    `/v1/job_positions/${jobPositionId}/applications/skill_comparison`
  );
}

// Contacts URL Constructors
export function getContactsUrlConstruct(companyId) {
  const base = hiredrateBridgeURL() + "/v1/contacts";
  if (companyId) {
    return `${base}?company_id=${companyId}`;
  }
  return base;
}

export function createContactUrlConstruct() {
  return hiredrateBridgeURL() + "/v1/contacts";
}

export function updateContactUrlConstruct(contactId) {
  return hiredrateBridgeURL() + "/v1/contacts/" + contactId;
}

export function getCountriesUrlConstruct(search = "") {
  const base = hiredrateBridgeURL() + "/v1/countries";
  if (search) {
    return `${base}?search=${encodeURIComponent(search)}`;
  }
  return base;
}

export function getStatesUrlConstruct(search = "", countryId = null) {
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  if (countryId) params.append("country_id", countryId);
  const query = params.toString();
  return hiredrateBridgeURL() + "/v1/states" + (query ? `?${query}` : "");
}

export function planUpgradeUrl() {
  return hiredrateBridgeURL() + "/v1/plan-upgrade";
}

// http://localhost:8069/v1/subscription-details/${customerId}
export function getSubscriptionDetailsByCustomerId(customerId) {
  return hiredrateBridgeURL() + "/v1/subscription-details/"+customerId;
}


export function getAddonsUrl(pageNo, limit = 20) {
  return (
    hiredrateBridgeURL() +
    "/v1/subscription_addons?page=" +
    pageNo +
    "&limit="+limit
  );
}


export function purchasChargeAddonUrl() {
  return hiredrateBridgeURL() + "/v1/purchase-charge";
}


export function getTransactionHistoryUrl(customerId) {
  return hiredrateBridgeURL() + "/v1/transactions/history/"+customerId;
}

// transaction details fro
export function getTransactionDetailsByCustomerAndTransactionIdUrl(customerId, transactionId) {
  return hiredrateBridgeURL() + "/v1/transactions/detail?customer_id="+customerId+"&transaction_id="+transactionId;
}

// "http://localhost:8069/v1/end-trial-add-card",
export function getEndTrialAddCardUrl() {
  return hiredrateBridgeURL() + "/v1/end-trial-add-card";
}

export function getVerifyHostedPageUrl() {
  return hiredrateBridgeURL() + "/v1/verify-hosted-page";
}


export function getVerifyPurchaseWithTransactionId(transactionId) {
  return hiredrateBridgeURL() + "/v1/verify-payment?purchase_tx_id="+transactionId;
}



export function getCustomerPortalUrl() {
  return hiredrateBridgeURL() + "/v1/customer-portal";
}

export function getManagePaymentMethodsUrl() {
  return hiredrateBridgeURL() + "/v1/manage-payment-method";
}